import HelloList from './HelloList';
import camelCase from './camelCase';

export default {
  getHelloGreet: (country?: string) => {
    const helloGreet = country
      ? HelloList.find((greet) => {
          return greet.country === camelCase(country);
        })
      : '';
    return helloGreet ? helloGreet.greet : 'Hello';
  },
};
